import { ApiClient, resolveApiBaseUrl } from "@/api/client";
import { createSessionApi } from "@/features/auth/api/session";
import { HttpClient } from "@/shared/api/http-client";

const REFRESH_TOKEN_STORAGE_KEY = "memoru_refresh_token";

function discardLegacyTokens() {
  try {
    localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
  } catch {
    // Cookie-backed sessions still work when storage is unavailable.
  }
}

discardLegacyTokens();

const recoverSessionRef = { current: async (): Promise<boolean> => false };

export const httpClient = new HttpClient({
  baseUrl: resolveApiBaseUrl(),
  onUnauthorized: () => recoverSessionRef.current(),
});

export const authApiClient = new ApiClient({
  baseUrl: resolveApiBaseUrl(),
  onUnauthorized: () => recoverSessionRef.current(),
});

export const sessionApi = createSessionApi(httpClient);

export const sessionHandlers = {
  setRecoverHandler: (handler: () => Promise<boolean>) => {
    recoverSessionRef.current = handler;
  },
};
